import {FormikErrors} from 'formik';
import {get, set} from 'lodash-es';
import type {newSubplanFields} from './builderSetUpNewFields';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {hasWrapper} from '../CreateBuilder/BuilderSourceDestination/builderUtils';
import {
  validateTextField,
  validateMandateField,
} from '../CreateBuilder/BuilderSourceDestination/builderValidators';
import {planFeesFieldType} from '../CreateBuilder/BuilderPlanFees';

export const setUpNewValidator = (
  values: builderFieldsType,
  errors: FormikErrors<builderFieldsType>
): FormikErrors<builderFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const setUpNewValues = values.setUpNew;
  if (!setUpNewValues) {
    errors.setUpNew = 'Fill in fields';
    return errors;
  }

  newPlanValidator({
    values,
    errors,
    formikKeyPrefix: `setUpNew`,
  });
  return errors;
};

type subplanValidatorArgs = {
  values: builderFieldsType;
  errors: FormikErrors<builderFieldsType>;
  formikKeyPrefix: string;
  context:
    | OVRecommendActionEnum.CONTRIBUTE
    | OVRecommendActionEnum.TRANSFER
    | OVRecommendActionEnum.SET_UP_NEW;
};
export const newSubplanValidator = ({
  errors,
  values,
  formikKeyPrefix,
  context,
}: subplanValidatorArgs): void => {
  validateTextField(
    get(values, `${formikKeyPrefix}.planProvider`),
    `${formikKeyPrefix}.planProvider`,
    errors
  );

  validateMandateField(
    get(values, `${formikKeyPrefix}.model`),
    `${formikKeyPrefix}.model`,
    errors
  );
};

export const planFeeValidator = ({
  values,
  formikKeyPrefix,
  errors,
}: {
  values: builderFieldsType;
  errors: FormikErrors<builderFieldsType>;
  formikKeyPrefix: string;
}): void => {
  const planFees = get(
    values,
    `${formikKeyPrefix}.planFees`
  ) as unknown as planFeesFieldType | null;
  if (!planFees) {
    set(errors, `${formikKeyPrefix}.planFees`, 'Please set plan fees');
    return;
  }
  if (planFees.DFMFeeRequired && !planFees.DFMFeeId) {
    set(errors, `${formikKeyPrefix}.planFees.DFMFeeId`, 'Required');
  }
  if (planFees.productFeeRequired && !planFees.productFeeId) {
    set(errors, `${formikKeyPrefix}.planFees.productFeeId`, 'Required');
  }
  if (planFees.FPFeeRequired && !planFees.FPFeeId) {
    set(errors, `${formikKeyPrefix}.planFees.FPFeeId`, 'Required');
  }
};

type newPlanValidatorArgs = {
  values: builderFieldsType;
  errors: FormikErrors<builderFieldsType>;
  formikKeyPrefix: string;
  // context:
  //   | OVRecommendActionEnum.CONTRIBUTE
  //   | OVRecommendActionEnum.TRANSFER
  //   | OVRecommendActionEnum.SET_UP_NEW;
  isLowesPension?: boolean;
  isTransactBond?: boolean;
  isMinor?: boolean;
};
export const newPlanValidator = ({
  values,
  errors,
  formikKeyPrefix,
  // context,
  isLowesPension = false,
  isTransactBond = false,
  isMinor = false,
}: newPlanValidatorArgs): void => {
  validateTextField(
    get(values, `${formikKeyPrefix}.parent.productNameId`),
    `${formikKeyPrefix}.parent.productNameId`,
    errors
  );
  validateTextField(
    get(values, `${formikKeyPrefix}.parent.planProvider`),
    `${formikKeyPrefix}.parent.planProvider`,
    errors
  );
  if (isMinor && !get(values, `${formikKeyPrefix}.parent.parentGuardianId`)) {
    set(errors, `${formikKeyPrefix}.parent.parentGuardianId`, 'Required');
  }
  // TODO: check if everything has subplans now
  const subplans = get(values, `${formikKeyPrefix}.subplans`, []) as newSubplanFields[];

  if (!subplans.length) {
    set(errors, `${formikKeyPrefix}.subplans`, 'At least one subplan must be selected');
  }

  subplans.forEach((_, index) => {
    newSubplanValidator({
      errors,
      formikKeyPrefix: `${formikKeyPrefix}.subplans.${index}`,
      values,
      context: OVRecommendActionEnum.SET_UP_NEW,
    });
  });

  console.log({errors});
};
